import {usePathRelatedStyles} from "../../../hooks/usePathRelatedStyles";

export const BodyWrapper = () => {
  usePathRelatedStyles();

  return null;
}